import { isDefined } from 'utils/tsHelpers';
import { INSIGHT_PANEL_SIZES } from '../../../constants';
import { useTranslation } from '../../../hooks';
import { InsightType } from '../../../types';
import {
  NumberWrapper,
  NumberInsightPanel as NumberInsightPanelWrapper,
} from './BehaviorInsights.styled';

type NumberInsightPanelProps = {
  title: string;
  value?: string;
  isLoading?: boolean;
  type?: InsightType;
  isZero?: boolean;
  isCustom?: boolean;
};

export const testIds = {
  placeholder: 'insights-placeholder',
  emptyInsight: 'insights-empty-data',
};

export const NumberInsightPanel = ({
  title,
  value,
  type,
  isZero = false,
  isCustom = false,
}: NumberInsightPanelProps) => {
  const { t } = useTranslation();
  /** a value should only be undefined if it's still processing due to cache */

  const getPlaceholderMessage = () => {
    if (isCustom && !isDefined(value)) {
      return <span data-test={testIds.placeholder}>{t('insights.placeholder.behavioral')}</span>;
    } else if (!isCustom && !isDefined(value)) {
      return <span data-test={testIds.emptyInsight}>{t('insights.empty.data')}</span>;
    } else {
      return value;
    }
  };

  return (
    <NumberInsightPanelWrapper type={type} title={title} size={INSIGHT_PANEL_SIZES.small}>
      <NumberWrapper data-defined={!isZero && isDefined(value)}>
        {getPlaceholderMessage()}
      </NumberWrapper>
    </NumberInsightPanelWrapper>
  );
};
